import { Component } from '@angular/core';

@Component({
    selector: 'app-view-new-organization',
    templateUrl: './view-new-organization.component.html',
    styleUrls: ['./view-new-organization.component.scss'],
    standalone: false
})
export class ViewNewOrganizationComponent {}
